import React from 'react';
import PropTypes from 'prop-types';
import {
  GridList,
  GridTile,
} from 'material-ui';
import CheckBox from 'material-ui/svg-icons/toggle/check-box';
import CheckBoxBlank from 'material-ui/svg-icons/toggle/check-box-outline-blank';
import muiThemeable from 'material-ui/styles/muiThemeable';

const getStyles = ({ palette: { primary1Color } }) => ({
  root: {
    height: '100%',
    position: 'relative',
  },
  icon: {
    zIndex: 10,
    position: 'absolute',
    right: 12,
    top: 12,
    color: primary1Color,
  },
  shade: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 10,
    background: 'rgba(0, 0, 0, 0.4)',
  },
});

class TileEffects extends React.Component {
  state = {
    hovering: false,
  }

  hover = () => this.setState({ hovering: false });
  unHover = () => this.setState({ hovering: true });

  render() {
    const {
      isSelected,
      muiTheme, children,
    } = this.props;
    const styles = getStyles(muiTheme);
    let icon = (<CheckBoxBlank style={styles.icon} />);
    if (this.state.hovering || isSelected) {
      icon = (<CheckBox style={styles.icon} />);
    }
    return (
      <div
        style={styles.root}
        onMouseOut={this.hover}
        onMouseOver={this.unHover}
        onBlur={this.unHover}
        onFocus={this.hover}
      >
        {!isSelected && !this.state.hovering && (<div style={styles.shade} />)}
        {icon}
        {children}
      </div>
    );
  }
}

const TileEffectsWithTheme = muiThemeable()(TileEffects);

const GalleryInput = (props) => {
  const {
    selections, selected, onSelect,
    titleIfSelected, subTitleIfSelected,
  } = props;
  const gridList = {
    maxWidth: 600,
  };
  return (
    <GridList
      cellHeight="200"
      style={gridList}
    >
      {(selections || []).map(({ key, src }) => {
        const isSelected = key === selected;

        return (
          <TileEffectsWithTheme isSelected={isSelected}>
            <GridTile
              key={key}
              title={isSelected ? titleIfSelected : null}
              subtitle={isSelected ? subTitleIfSelected : null}
              onClick={() => { onSelect(key); }}
            >
              <img src={src} alt="An option" />
            </GridTile>
          </TileEffectsWithTheme>
        );
      })}
    </GridList>
  );
};

GalleryInput.propTypes = {
  titleIfSelected: PropTypes.string,
  subTitleIfSelected: PropTypes.string,
  onSelect: PropTypes.func,
  selections: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    src: PropTypes.string,
  })),
  selected: PropTypes.string,
};

export default GalleryInput;
